import { Document, Page, Text, View, Image } from "@react-pdf/renderer";
import Header from "../../../../assets/images/logo/Letterhead Header.png";
import PrintApplicationStyles from "./PrintApplicationStyles.js";
import { margin } from "@mui/system";

import { formatPrintDate } from "./formatPrintDate";

const ReferenceAuthorisationFormPDF = ({ userId, section11 }) => {
  return (
    <Document>
      <Page size="A4" style={PrintApplicationStyles.page}>
        <Image src={Header} />
        <Text
          style={{
            ...PrintApplicationStyles.sectionheader,
            textAlign: "center",
            textDecoration: "underline",
            marginTop: 20,
            marginBottom: 10,
          }}
        >
          Applicant Reference Consent Form
        </Text>

      
        <Text style={PrintApplicationStyles.subcontent}>
          Company Name: Rosemount Financial Solutions (IFA) Ltd
        </Text>
        <Text style={PrintApplicationStyles.subcontent}>
          Company FCA Number: 535515
        </Text>
        <Text style={{ ...PrintApplicationStyles.content, marginTop: 20 }}>
          My signature below authorises my former employers and referees to
          release information regarding my employment record with Rosemount
          Financial Solutions (IFA) Ltd and to provide any additional
          information that may be necessary for my application for employment
          with them.
        </Text>
        <Text style={{ ...PrintApplicationStyles.content, marginBottom: 30 }}>
          I understand and acknowledge that any offer of appointment is
          conditional to Rosemount Financial Solutions (IFA) Ltd being
          completely satisfied with the information provided by these
          references.
        </Text>
        <View style={PrintApplicationStyles.inputRow}>
          <Text style={PrintApplicationStyles.inputLabel}>Print Name</Text>
          <View style={PrintApplicationStyles.inputBox}>
            <Text>{section11?.printName || ""}</Text>
          </View>
        </View>
        <View style={PrintApplicationStyles.inputRow}>
          <Text style={PrintApplicationStyles.inputLabel}>Signature</Text>
          <View style={PrintApplicationStyles.inputBox}>
            {section11?.printNameSignature ? (
              <Image src={section11?.printNameSignature} />
            ) : (
              <Text>Not provided</Text>
            )}
            {/* <Image src={section11?.candidateSignature} /> */}
          </View>
        </View>
        <View style={PrintApplicationStyles.inputRow}>
          <Text style={PrintApplicationStyles.inputLabel}>Date:</Text>
          <View style={PrintApplicationStyles.inputBox}>
            <Text>
              {formatPrintDate(section11?.printNameDate)}
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default ReferenceAuthorisationFormPDF;
